import { Component, Input, Output, EventEmitter, OnInit, ElementRef, Renderer2 } from '@angular/core';

@Component({
  selector: 'bz-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: ['./time-picker.component.scss']
})
export class TimePickerComponent implements OnInit {
  @Input() dateInput: Date;
  @Output() timeChange = new EventEmitter<Date>();
  @Input() isVisible: boolean = false;
  @Input() showIcon: boolean = true;
  @Input() showSeconds: boolean = false;

  hours: string;
  minutes: string;
  seconds: string;
  hoursArray: string[] = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  minutesArray: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  secondsArray: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this.updatePosition();
  }

  ngOnChanges() {
    if (this.dateInput) {
      this.hours = this.dateInput.getHours().toString().padStart(2, '0');
      this.minutes = this.dateInput.getMinutes().toString().padStart(2, '0');
      this.seconds = this.dateInput.getSeconds().toString().padStart(2, '0');
    }
    
    if (this.isVisible) {
      setTimeout(() => this.updatePosition(), 0);
    }
  }

  private updatePosition() {
    if (this.isVisible && this.elementRef.nativeElement) {
      const parentElement = this.elementRef.nativeElement.parentElement;
      if (parentElement) {
        const rect = parentElement.getBoundingClientRect();
        const timePickerElement = this.elementRef.nativeElement.querySelector('.time-picker');
        
        if (timePickerElement) {
          this.renderer.setStyle(timePickerElement, 'top', `${rect.bottom + 2}px`);
          this.renderer.setStyle(timePickerElement, 'right', `${window.innerWidth - rect.right}px`);
          this.renderer.setStyle(timePickerElement, 'left', 'auto');
        }
      }
    }
  }

  updateTime() {
    const updatedTime = new Date(this.dateInput);
    updatedTime.setHours(Number(this.hours));
    updatedTime.setMinutes(Number(this.minutes));
    updatedTime.setSeconds(Number(this.seconds));
    this.timeChange.emit(updatedTime);
  }

  confirmAndClose() {
    this.updateTime();
    this.isVisible = false;
  }

  selectMinute(minute: string) {
    this.minutes = minute;
    this.updateTime();
  }

  selectHour(hours: string) {
    this.hours = hours;
    this.updateTime();
  }

  selectSecond(second: string) {
    this.seconds = second;
    this.updateTime();
  }
}